<template>
    <v-container class="fill-height" fluid>
        <v-container>
            <v-row>
                <v-col cols="12" class="display-1" align="center">
                    {{ $t('tv-quick-support')}}
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" align="center">
                    <v-btn href="https://get.teamviewer.com/network-it" target="_blank">{{ $t('tv-download')}}</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    export default {
        name: "SupportPage"
    }
</script>

<style scoped>

</style>